import PropTypes from 'prop-types';
import React from 'react';

import InputType from '../input-type';

export const TextInput = (props) => <InputType type={props.type || 'text'} {...props} />;

TextInput.propTypes = {
    type: PropTypes.string,
    error: PropTypes.string,
};
